module.exports = __webpack_public_path__ + "static/media/register.77df8132.svg";